import { Badge, Tooltip, TooltipTrigger } from "@light-technology/components";
import type { AppAccount } from "../../state/api.types";
import {
  getAccountStatusTooltip,
  getStatusDisplay,
} from "./accountStatusHelpers";

type AccountStatusProps = {
  account: AppAccount;
  showTooltip?: boolean;
  showDescription?: boolean;
};

export const AccountStatus = ({
  account,
  showTooltip = false,
  showDescription = false,
}: AccountStatusProps) => {
  const { label, badgeColor } = getStatusDisplay(account.status);
  const statusText = getAccountStatusTooltip(account);

  const badge = (
    <Badge size="sm" color={badgeColor} type="pill-color">
      {label}
    </Badge>
  );

  // Description mode (for details view)
  if (showDescription) {
    return (
      <div>
        {badge}
        {statusText && (
          <div className="mt-xs text-xs text-tertiary">{statusText}</div>
        )}
      </div>
    );
  }

  // Tooltip mode (for list view)
  if (showTooltip && statusText) {
    return (
      <Tooltip title={statusText} placement="top" arrow>
        <TooltipTrigger>{badge}</TooltipTrigger>
      </Tooltip>
    );
  }

  // Default: just the badge
  return badge;
};
